import React, {FC} from "react"
import styled from "styled-components"

import {Deal} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import Icon from "@irati/ui/src/Icon"
import {H5} from "@irati/ui/src/Typography"
import DealHighlight from "@irati/deals/constants/dealHighlightTypes"
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited"

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  ${Icon} {
    margin-right: 5px;
  }
  margin-bottom: 20px;
`

interface Props {
  deal: Deal
}

const TimeLimitedDeal: FC<Props> = ({deal}) => {
  if (!isTimeLimited(deal)) {
    return null
  }
  return (
    <StyledRow>
      <Icon size={45} icon={DealHighlight.TIME_LIMIT_24_HOUR} />
      <H5 as="strong">
        <FormattedMessage id="perks.components.importantInfoBlock.timeLimited" />
      </H5>
    </StyledRow>
  )
}

export default TimeLimitedDeal
